<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { WifiOff, Wifi } from 'lucide-vue-next'

const isOffline = ref(!navigator.onLine)
const showReconnected = ref(false)

function handleOffline() {
  isOffline.value = true
  showReconnected.value = false
}

function handleOnline() {
  isOffline.value = false
  showReconnected.value = true
  setTimeout(() => {
    showReconnected.value = false
  }, 3000)
}

onMounted(() => {
  window.addEventListener('offline', handleOffline)
  window.addEventListener('online', handleOnline)
})

onUnmounted(() => {
  window.removeEventListener('offline', handleOffline)
  window.removeEventListener('online', handleOnline)
})
</script>

<template>
  <!-- Offline Banner -->
  <Transition
    enter-active-class="transition-transform duration-300 ease-out"
    enter-from-class="-translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transition-transform duration-200 ease-in"
    leave-from-class="translate-y-0"
    leave-to-class="-translate-y-full"
  >
    <div
      v-if="isOffline"
      class="fixed top-0 left-0 right-0 z-[9998] bg-red-600 text-white shadow-lg"
    >
      <div class="container mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm font-bold">
        <WifiOff class="w-4 h-4" />
        <span>Offline — i dati mostrati potrebbero non essere aggiornati</span>
      </div>
    </div>
  </Transition>

  <!-- Reconnected Flash -->
  <Transition
    enter-active-class="transition-transform duration-300 ease-out"
    enter-from-class="-translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transition-transform duration-200 ease-in"
    leave-from-class="translate-y-0"
    leave-to-class="-translate-y-full"
  >
    <div
      v-if="showReconnected"
      class="fixed top-0 left-0 right-0 z-[9998] bg-green-600 text-white shadow-lg"
    >
      <div class="container mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm font-bold">
        <Wifi class="w-4 h-4" />
        <span>Connessione ripristinata</span>
      </div>
    </div>
  </Transition>
</template>
